import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { provideRouter } from "@angular/router";
import { provideNgGlyphs, provideNgGlyphsConfig } from "@ng-icons/core";
import { withMaterialSymbolsOutlined } from "@ng-icons/material-symbols";
import { routes } from "./AppRoutes";
import { GlobalErrorHandler } from "./Modules/Error/ErrorHandler";
import { AuthInterceptor } from "./Modules/Auth/Interceptors/AuthInterceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideNgGlyphs(withMaterialSymbolsOutlined()),
    provideNgGlyphsConfig({
      weight: 200,
      grade: 200,
      opticalSize: 24,
      size: "24px",
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
